<div class="menu {{classCustom}}">
  <div class="button-open">
    <button type="button" class="menu-open" (click)="_open()">
        <i class="material-icons">menu</i>   
    </button>    
  </div>  
  <div class="close" #close (click)="_open()">  
    <i class="material-icons">close</i>
  </div>   
  <div class="menu-content" #content> 
      <ul>
          <li>
              <a routerLink="/" title="Igreja Greenhouse">
                Home
              </a>    
          </li>
          <li class="has-sub">
            <a href="javascript::void();" title="Nos conheça" class="link" (click)="_show('.menu-sub-1')">
              Nos conheça
              <i class="material-icons">expand_more</i>
            </a>   
            <ul class="menu-sub menu-sub-1 scale-up-ver-bottom">
              <li>
                <a routerLink="quem-somos/conheca-a-nossa-igreja" title="Conheça a nossa igreja - Igreja Greenhouse">
                  Conheça a nossa igreja
                </a>
              </li> 
              <li>
                <a routerLink="quem-somos/lideranca" title="Liderança - Igreja Greenhouse">
                  Liderança
                </a>
              </li>  
            </ul> 
          </li>
          <!--<li class="has-sub">
            <a href="javascript::void();" title="Conectar" class="link" (click)="_show('.menu-sub-2')">
              Conectar
              <i class="material-icons">expand_more</i>
            </a> 
            <ul class="menu-sub menu-sub-2 scale-up-ver-bottom">
              <li>
                <a routerLink="conexoes" title="Conexões - Igreja Greenhouse">
                  Conexões
                </a>
              </li> 
              <li>
                <a routerLink="jejum-coletivo" title="Jejum Coletivo - Igreja Greenhouse">
                  Jejum Coletivo
                </a>
              </li>  
            </ul>   
          </li>-->
          <li class="has-sub">
            <a href="javascript::void();" class="link" title="Capacitação" (click)="_show('.menu-sub-3')">
              Capacitação
              <i class="material-icons">expand_more</i>
            </a>
            <ul class="menu-sub menu-sub-3 scale-up-ver-bottom">
              <li> 
                <a routerLink="greenhouse-school" title="Capacitação - Greenhouse School">
                  Greenhouse School
                </a>
              </li>  
            </ul>     
          </li>
          <li>
            <a href="javascript::void();" title="Cultos" (click)="toSection('#section-cultos')">   
              Cultos
            </a>    
          </li>
          <li>
            <a routerLink="agenda" title="Agenda">   
              Agenda
            </a>    
          </li>
          <li>
            <a routerLink="negocios" title="Negócios">   
              Negócios
            </a>    
          </li>
          <li>
              <a routerLink="contato" title="Contato Greenhouse">
                Contato
              </a>    
          </li>
          <li>
            <a routerLink="dizimos-e-ofertas" title="Dízimos e Ofertas">
              Dízimos e Ofertas
            </a>    
        </li>
      </ul>  
  </div> 
</div> 
<div class="overlay" #overlay></div>      
